import { takeUntil } from 'rxjs/operators';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { select, Store } from '@ngrx/store'

import { Observable } from 'rxjs'

import * as meta from '../../actions/meta'
import * as orders from '../../actions/orders'
import * as cart from '../../../cart/actions/cart'

import * as fromOrders from '../../reducers'
import * as fromCart from '../../../cart/reducers'
import * as fromAuth from '../../../auth/reducers'

import { ErpOrder } from '../../models/orderline'
import { ContainerBase } from '../../../core/base/container-base';
import { AddCartEvent, ApiOrderline, CartProduct } from '../../../cart/models/cart-models';
import chaining from '../../../core/helpers/chaining';
import * as fromBase from '../../../base/reducers';

@Component({
  selector: 'app-order-page-container',
  templateUrl: './order-page-container.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderPageContainer extends ContainerBase {
  orders$: Observable<ErpOrder[]>
  loadingLines$: Observable<boolean>
  cartProducts$: Observable<{[_id: string]: CartProduct}>
  currency$: Observable<string>
  orderLines$: Observable<ApiOrderline[]>
  orderLines: ApiOrderline[]
  isExpanding$: Observable<boolean>

  fullWidthView$: Observable<boolean>

  constructor(
    private store: Store<fromOrders.State>
  ) {
    super()

    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )

    this.orders$ = store.pipe(
      select(fromOrders.getOrders),
      takeUntil(this.destroyed$))

    this.loadingLines$ = store.pipe(
      select(fromOrders.isLinesLoading),
      takeUntil(this.destroyed$))

    this.cartProducts$ = store.pipe(
      select(fromCart.getCartProducts),
      takeUntil(this.destroyed$))

    this.currency$ = store.pipe(
      select(fromAuth.getCurrency),
      takeUntil(this.destroyed$))

    this.orderLines$ = store
      .pipe(
        select(fromCart.getCurrentOrderLines),
        takeUntil(this.destroyed$)
      )

    this.isExpanding$ = store.pipe(
      select(fromOrders.isExpanding),
      takeUntil(this.destroyed$)
    )

    // Dispatch init
    this.store.dispatch(new meta.Init())

    this.orderLines$
      .subscribe(orderLines => this.orderLines = orderLines)
  }

  expand() {
    this.store.dispatch(new orders.Expand())
  }

  addCart(event: AddCartEvent) {
    const orderLineId = chaining(this.orderLines.find(line => chaining(line, 'product._id') === chaining(event, 'product')), '_id')

    if (chaining(event, 'quantity') > 0) {
      this.store.dispatch(new cart.Add({
        product: event.product,
        quantity: event.quantity
      }))
    } else if (event.quantity <=0 && orderLineId)
      this.store.dispatch(new cart.Remove({
        lineId: orderLineId
      }))
  }
}
